// extracted by mini-css-extract-plugin
export default {"root":"WnA2HTAUIQdfJDgIYcRQ"};